// 3LINK Solutions brand configuration
export const BRAND_CONFIG = {
  company: {
    name: '3LINK Solutions',
    website: 'threelink.com',
    websiteUrl: 'https://threelink.com',
    mainPhone: '844.443.5465',
  },

  colors: {
    orange: '#F96714',
    navy: '#1A2B5E',
    gray: '#6B7280',
    text: '#1F2937',
    link: '#2563EB',
  },

  taglines: [
    'Your Link to Exceptional Workday Professionals',
    'Connecting You to Workday Excellence',
  ],

  partners: [
    {
      id: 'services',
      label: 'Services Partner',
      asset: '/assets/brand/certifications/thumbnail_wday-partners-logo-services-partner@4x.png',
    },
    {
      id: 'staffing',
      label: 'Staffing Partner',
      asset: '/assets/brand/certifications/wday-partners-logo-staffing-partner@4x.png',
    },
    {
      id: 'advisory',
      label: 'Advisory Partner',
      asset: '/assets/brand/certifications/wday-partners-logo-advisory-partner@4x.png',
    },
  ],

  assets: {
    chainLogo: '/assets/brand/logos/chainlink_orange.png',
    emailIcon: '/assets/brand/icons/email.png',
    linkedinIcon: '/assets/brand/icons/linkedin.png',
    websiteIcon: '/assets/brand/icons/website.png',
  },
};

export default BRAND_CONFIG;
